var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.9375 9.95451L10.705 13.9741C10.7778 14.0174 10.8543 14.0487 10.932 14.0685V21.8644L4.42016 17.8997C4.12099 17.7176 3.9375 17.3865 3.9375 17.0289V9.95451ZM19.6752 9.84766V17.0289C19.6752 17.3865 19.4917 17.7176 19.1925 17.8997L12.6807 21.8644V14.0002C12.6965 13.9921 12.7123 13.9834 12.7278 13.9741L19.6752 9.84766Z",
    fill: "#2A85FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.14844 8.00398C4.2311 7.89659 4.33543 7.80583 4.45708 7.73918L11.3423 3.96644C11.6314 3.80806 11.9781 3.80806 12.2671 3.96644L19.1524 7.73918C19.2461 7.79056 19.3296 7.85626 19.4008 7.93287L11.8519 12.4166C11.8022 12.4461 11.7565 12.4799 11.7148 12.5171C11.6731 12.4799 11.6273 12.4461 11.5777 12.4166L4.14844 8.00398Z",
    fill: "#6F767E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCube);
export default __webpack_public_path__ + "static/media/cube.89f68be298f30fe6e9ea434f4bfcca99.svg";
export { ForwardRef as ReactComponent };